import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "own-list" }
const _hoisted_2 = ["src", "alt", "onClick"]
const _hoisted_3 = { class: "tooltip" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "constellation" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.characterList, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.key
        }, [
          _createElementVNode("img", {
            class: _normalizeClass('character' + _ctx.bgImageClass(item) + _ctx.notOwnedClass(item)),
            src: item.icon_url,
            alt: item.key,
            onClick: ($event: any) => (_ctx.onClick(item))
          }, null, 10, _hoisted_2),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.displayName(item.key)), 1),
          _createElementVNode("img", {
            class: "vision",
            src: _ctx.visionSrc(item),
            alt: item.元素
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.constellationObj[item.key]), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("label", null, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.savable) = $event)),
        disabled: !_ctx.changed
      }, null, 8, _hoisted_6), [
        [_vModelCheckbox, _ctx.savable]
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.displayName("キャラクター所持状況を保存する")), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
      disabled: !_ctx.savable
    }, _toDisplayString(_ctx.displayName("実行")), 9, _hoisted_7)
  ], 64))
}